import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import { FormattedMessage } from 'react-intl';
import { Navigate, useParams } from 'react-router-dom';
import { initialModelVariantState } from '../../reducers/initialState';
import Cookies from 'js-cookie';

const envName = process.env.REACT_APP_ENV_NAME_SHORT;

const ModelVariantConfiguration = ({ userProfileWidgets }) => {

  // Check if the user has access to any of the widgets
  let { ModelCategoryId, ModelId, ModelVariantId } = useParams();



  return (
    <div>
      {IsWidgetAccessible(userProfileWidgets, 'MODELVARIANT_UNIT_VIEW') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variant-configuration/${ModelVariantId}/model-variant-units-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTSETPOINTS') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variant-configuration/${ModelVariantId}/model-variant-setpoints-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTTHRESHOLDS') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variant-configuration/${ModelVariantId}/model-variant-thresholds-list`} />
      ) : (
        ''
      )}
      <span>
        <FormattedMessage
          id="modelVariant.noAccess"
          defaultMessage="You do not have access to model variant operations. Please contact your administrator."
        />
      </span>
    </div>
  )
};

ModelVariantConfiguration.propTypes = {
  userProfileWidgets: PropTypes.object.isRequired
};

export default ModelVariantConfiguration;
